export const API_BASE_URL = `https://bvg13n8tsj.execute-api.ap-northeast-2.amazonaws.com/prod`;
